import { useRouter } from 'next/router';
import { useState, useCallback } from 'react';
import i18nStore from '../public/locales/index';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import HomeComp from '../component/home';
import Head from 'next/head';


const DEFAULT_LAN = 'en';
const themeColors = {
  0: '#8149f9',
  1: '#fd66ca',
  2: '#0a98fb',
};


export default function ({ translations }) {
  const router = useRouter();
  const [activeIndex, setActiveIndex] = useState(0);

  // 处理索引变化的回调函数
  const handleIndexChange = useCallback((index) => {
    setActiveIndex(index);
  }, []);
  const { lan = DEFAULT_LAN } = router.query;
  // 初始化i18next
  async function initI18n(trans) {
    i18n.use(initReactI18next).init({
      resources: trans,
      lng: lan,
      fallbackLng: lan,
      interpolation: {
        escapeValue: false,
      },
    });
  }
  initI18n(translations);

  return (
    <I18nextProvider i18n={i18n}>
      <Head>
        <meta name="theme-color" content={themeColors[activeIndex]} />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content={themeColors[activeIndex]} />
      </Head>
      <HomeComp onIndexChange={handleIndexChange} />
    </I18nextProvider>
  );
}

export async function getServerSideProps() {
  // const translationsRes = await fetchTranslations();
  const lan = DEFAULT_LAN;
  // const { token } = await getMyToken();

  // console.log(processTransltionData(translationsRes));
  const translations = { [lan]: i18nStore[lan] };
  // const translations = translationsRes ? { [lan]: processTransltionData(translationsRes)[lan] } : { [lan]: i18nStore[lan] };
  // const translations = { [lan]: i18nStore[lan] };
  // console.log('translations', processTransltionData(translationsRes));

  return {
    props: {
      translations,
      // url: process.env.API_URL,
      // accessToken: token,
      omiEnv: process.env.OMI_ENV || '',
      nodeEnv: process.env.NODE_ENV || '',
    },
  };
}
